import apiClient, { isApiConfigured } from "./axiosClient";

/**
 * Claim appeal / reconsideration API.
 *
 * When the portal API is configured (VITE_API_BASE_URL / config.json) these call
 * the live endpoints; otherwise they fall back to a localStorage mock so the
 * flow + "My Appeals" list work in demo mode.
 *
 * TODO(portal API): confirm the real endpoint paths + payload shape with the
 * backend team and update the two apiClient calls below. The mock shape mirrors
 * what the UI expects: { appealNumber, claimNumber, memberName, memberId, reason,
 * justification, status, submittedAt, documents:[names] }.
 */

const LS_KEY = "sendero_appeals";
const readMock = () => {
  try {
    return JSON.parse(localStorage.getItem(LS_KEY) || "[]");
  } catch {
    return [];
  }
};
const writeMock = (list) => {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(list));
  } catch {
    /* ignore */
  }
};

export const appealApi = {
  submitAppeal: async (payload) => {
    //alert("REACHED : " + JSON.stringify(payload));

    //return;

    const formData = new FormData();

    formData.append("ClaimNumber", payload?.claimNumber?.trim());
    formData.append("ClaimId", payload?.id || "");
    formData.append("GroupId", payload?.groupId || "");

    formData.append("MemberName", payload?.memberName?.trim());
    formData.append("MemberId", payload?.memberId?.trim());

    formData.append("ProviderName", payload?.provider?.name?.trim());

    formData.append("NPI", payload?.provider?.npi?.trim() || "");

    formData.append("TIN", payload?.provider?.tin?.trim() || "");

    formData.append("Reason", payload?.reason?.trim());

    formData.append("Justification", payload?.justification?.trim());

    formData.append("RequestedOutcome", payload?.requestedOutcome?.trim());

    formData.append("ContactEmail", payload?.contact?.email?.trim() || "");

    formData.append("ContactPhone", payload?.contact?.phone?.trim() || "");

    formData.append("UserId", payload?.userId?.trim() || "");

    // Add files
    payload?.documents?.forEach((file) => {
      // Only upload newly selected browser files.
      // Existing API attachments are not IFormFile objects.
      if (file instanceof File) {
        formData.append("Files", file);
      }
    });

    //console.log("FORM DATA:");

    //for (const [key, value] of formData.entries()) {
    //    console.log(key, value);
    //}

    const res = await apiClient.post(
      "/api/provider/submitClaimAppeal",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    const data = res?.data;

    return {
      success: data?.Success,
      message: data?.Message,
      data: data?.Data || [],
    };
  },
  updateAppeal: async (payload) => {
    /// alert("REACHED : " + JSON.stringify(payload));

    //return;

    const formData = new FormData();

    //formData.append("AppealId", payload?.appealId?.trim());
    formData.append("AppealId", String(Number(payload?.appealId)));

    formData.append("ClaimNumber", payload?.claimNumber?.trim());
    formData.append("ClaimId", payload?.id || "");
    formData.append("GroupId", payload?.groupId || "");

    formData.append("MemberName", payload?.memberName?.trim());
    formData.append("MemberId", payload?.memberId?.trim());

    formData.append("ProviderName", payload?.provider?.name?.trim());

    formData.append("NPI", payload?.provider?.npi?.trim() || "");

    formData.append("TIN", payload?.provider?.tin?.trim() || "");

    formData.append("Reason", payload?.reason?.trim());

    formData.append("Justification", payload?.justification?.trim());

    formData.append("RequestedOutcome", payload?.requestedOutcome?.trim());

    formData.append("ContactEmail", payload?.contact?.email?.trim() || "");

    formData.append("ContactPhone", payload?.contact?.phone?.trim() || "");

    formData.append("UserId", payload?.userId?.trim() || "");

    // Add files
    payload?.documents?.forEach((file) => {
      // Only upload newly selected browser files.
      // Existing API attachments are not IFormFile objects.
      if (file instanceof File) {
        formData.append("Files", file);
      }
    });

    //formData.append(
    //    "RemovedAttachmentIds",
    //    JSON.stringify(payload?.removedAttachmentIds)
    //);

    payload?.removedAttachmentIds.forEach((id) => {
      formData.append("RemovedAttachmentIds", String(id));
    });

    console.log("UPDATE FORM DATA:");

    for (const [key, value] of formData.entries()) {
      console.log(key, value);
    }

    //return;

    const res = await apiClient.post(
      "/api/provider/updateClaimAppeal",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    const data = res?.data;

    return {
      success: data?.Success,
      message: data?.Message,
      data: data?.Data || [],
    };
  },

  /** List the provider's appeals. Returns { data: { Success, Data:[…] } }. */
  listAppeals: async (params) => {
    const res = await apiClient.get("/api/provider/getClaimAppealList");

    const data = res?.data;

    return {
      success: data?.Success,
      message: data?.Message,
      data: data?.Data || [],
    };
  },
  listAppeals2: async ({
    searchText = "",
    status = "All",
    sortColumnName = "",
    sortColumnDirection = "",
    startIndex = 0,
    pageSize = 10,
    exportCsv = false,
  } = {}) => {
    const response = await apiClient.get("/api/provider/getClaimAppealList2", {
      params: {
        searchText,

        status: status === "All" ? "" : status,

        sortColumnName,
        sortColumnDirection,

        startIndex,
        pageSize,

        exportCsv,
      },
    });

    const result = response?.data;

    return {
      success: result?.Success,
      message: result?.Message,

      data: result?.Data || [],

      totalRecord: result?.TotalRecord || 0,

      statusCounts: result?.StatusCounts || [],

      startIndex: result?.StartIndex || 0,

      pageSize: result?.PageSize || pageSize,
    };
  },
  getAppealAttachments: async (appealId) => {
    const res = await apiClient.get(
      `/api/provider/getClaimAppealAttachments/${appealId}`,
    );
    return res;
  },

  getAttachmentFile: async (attachmentId) => {
    const res = await apiClient.get(
      `/api/provider/claimAppeal/attachments/${attachmentId}/previewAndDownload`,
      {
        responseType: "blob",
      },
    );

    return res;
  },
  getAppeal: async (params) => {
    //alert("APPEAL ID AT GET APPEL API :" + params.appealId);

    const res = await apiClient.get(
      `/api/provider/getClaimAppeal/${params.appealId}`,
    );

    const data = res?.data;

    return {
      success: data?.Success,
      message: data?.Message,
      data: data?.Data || [],
    };
  },
  getStatusHistory: async (appealId) => {
    const response = await apiClient.get(
      `/api/provider/admin/getClaimAppealStatusHistory/${appealId}`,
    );

    return response.data;
  },
  updateClaimAppealStatus: async (params) => {
    console.log("CLAIM APPEAL UPDATE STATUS PARAMS:", JSON.stringify(params));

    const request = {
      appealId: params.id,
      status: params.newStatus,
      notes: params.statusNotes,
    };

    const res = await apiClient.post(
      "/api/provider/admin/updateClaimAppealStatus",
      request,
    );

    const data = res?.data;

    return {
      success: data?.Success,
      message: data?.Message,
      data: data?.Data || [],
    };
  },
};

export default appealApi;
